module.exports = __webpack_public_path__ + "img/camion.fd916446.png";